import { render, staticRenderFns } from "./lzjh-pdf.vue?vue&type=template&id=4b70ded2&"
import script from "./lzjh-pdf.vue?vue&type=script&lang=js&"
export * from "./lzjh-pdf.vue?vue&type=script&lang=js&"
import style0 from "./lzjh-pdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports